import { Component } from "preact";
import Navigation from "./components/Navigation/Navigation";
import Header from "./components/Header/Header";
import classNames from "classnames";
import Section from "./components/Section/Section";

import styles from "./styles/App.css";

export default class App extends Component {

	render(props, state, ctx) {
		return (
			<div id="root">
				<Navigation/>
				<Header/>

				<Section id="about">
					<h2 style={{ fontSize: 30, marginBottom: 10 }}>Our Services</h2>
					<ul style={{ fontSize: 21, marginTop: 0 }} class="lead">
						<li>
							Diagnostic and screening procedures
						</li>
						<li>
							Services for everyone
						</li>
						<li>
							Surgical procedures
						</li>
						<li>
							Treatment of disease, disorder or injury
						</li>
					</ul>
				</Section>

				<Section id="find" style={{ background: "#f8f9fa", paddingTop: 15, paddingBottom: 15 }}>
					<h2 style={{ fontSize: 30, marginBottom: 10 }}>Find us</h2>
					<iframe
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2354.622253541386!2d-1.564483384143214!3d53.83179568008364!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4879595c3578e1f5%3A0xcccf62bfa3f6e4e0!2sStonegate+Dental+Surgery!5e0!3m2!1sen!2suk!4v1534001813783"
						width="100%" height="500" frameBorder="0" style="border:0" allowFullScreen/>
				</Section>

				<Section id="contact">
					<h2 style={{ fontSize: 30, marginBottom: 10 }}>Contact</h2>
					<div className={styles.ContactGrid}>
						<div>
							<i style={{ fontSize: 70 }} class="material-icons">phone</i>
							<div style={{ fontSize: 26 }}>Call us</div>
							<div>(0113) 293 0380</div>
						</div>
						<div>
							<i style={{ fontSize: 70 }} class="material-icons">email</i>
							<div style={{ fontSize: 26 }}>Email</div>
							<div>tbc</div>
							{/*<div>contact@stonegatedental.co.uk</div>*/}
						</div>
					</div>
				</Section>

				<footer style={{
					background: "#337ab7",
					padding: 20,
					textAlign: "center",
					color: "#FFF",
					ontSize: 14
				}}>
					© 2018 Copyright: Conor Turner
				</footer>

			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./App.js